import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import * as api from 'api/methods';

import { useFetch } from 'hooks/useFetch';

import { convertDataToApi } from './CreateDailyChallenge.helpers';

import CreateDailyChallenge from './CreateDailyChallenge';

const CreateDailyChallengeContainer = ({
  open,
  ...restProps
}: { open: any } & Record<string, any>) => {
  const navigate = useNavigate();

  const [createLoading, setCreateLoading] = useState(false);

  const { data: schools } = useFetch(
    {
      defaultData: [],
      fetcher: api.getSchools,
      immediately: false,
      stopRequest: !open,
    },
    null,
    [open],
  );

  const handleCreateClick = async (
    values: any,
    { resetForm }: { resetForm: any },
  ) => {
    setCreateLoading(true);

    try {
      const dailyChallenge = await api.createDailyChallenge(
        convertDataToApi(values),
      );

      resetForm();

      navigate(`/daily-challenges/${dailyChallenge.id}`);
    } catch (error) {
      console.warn(error); // TODO: catch error
    }

    setCreateLoading(false);
  };

  const schoolOptions = schools.map((school: any) => ({
    label: school.name,
    value: school.id,
  }));

  return (
    <CreateDailyChallenge
      {...restProps}
      open={open}
      createLoading={createLoading}
      schoolOptions={schoolOptions}
      onCreateClick={handleCreateClick}
    />
  );
};

export default React.memo(CreateDailyChallengeContainer) as any;
